// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"16420f3e","513":"bc72343e","703":"7cdb6e60","787":"aa27889b"}[chunkId] + ".chunk.js";
};